import * as React from 'react'
import { ServerTimeContext } from '../contexts/serverTime.context'

export default function DisplayTime() {
  const { getCalibratedDateTime } = React.useContext(ServerTimeContext)
  const [date, setDate] = React.useState(getCalibratedDateTime())
  const hours = date.getHours()
  const minutes = date.getMinutes()

  React.useEffect(() => {
    const timeInterval = window.setInterval(() => {
      setDate(getCalibratedDateTime())
    }, 10_000)

    return function cleanup() {
      return window.clearInterval(timeInterval)
    }
  })

  return (
    <div>
      <span>{String(hours).padStart(2, '0')}</span>
      <span className="animate-transparency">:</span>
      <span>{String(minutes).padStart(2, '0')}</span>
    </div>
  )
}
